var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiArrows(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 124,
    height: 51.547,
    viewBox: "0 0 124 51.547",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 41",
    d: "M124 5.7735L114 -1.19209e-07V11.547L124 5.7735ZM0 5.7735V6.7735H115V5.7735V4.7735H0V5.7735Z",
    fill: "#1976D2",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 42",
    d: "M124 25.7735L114 20V31.547L124 25.7735ZM0 25.7735V26.7735H115V25.7735V24.7735H0V25.7735Z",
    fill: "#1976D2",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 43",
    d: "M124 45.7735L114 40V51.547L124 45.7735ZM0 45.7735V46.7735H115V45.7735V44.7735H0V45.7735Z",
    fill: "#1976D2",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 15",
    cx: 80.5,
    cy: 5.7735,
    r: 4.5,
    fill: "#0C45CC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 61.5,
    cy: 25.7735,
    r: 4.5,
    fill: "#0C45CC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 17",
    cx: 42.5,
    cy: 45.7735,
    r: 4.5,
    fill: "#0C45CC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiArrows);
export default __webpack_public_path__ + "static/media/api_arrows.853a0c10c089bd143ee77ee7846333fa.svg";
export { ForwardRef as ReactComponent };